import { StatusDisplay } from "@/components/overlays/StatusDisplay";
import { getContactSupportLink } from "@/features/branding";
import { Button } from "antd";
import { useTranslation } from "react-i18next";
export const AdaptationErrorRetry = ({
  onRetry
}: {
  onRetry: () => void;
}) => {
  const {
    t
  } = useTranslation("terms");
  return <StatusDisplay className="mt-2 !justify-start" status="error" title={`Failed to load ${t("resilience")} runs`} description={<div className="text-sm text-gray-500">
          An unexpected error occured while attempting to load ${t("resilience")} results. If the issue persists, please{" "}
          {getContactSupportLink()}.
        </div>} actions={<Button onClick={onRetry}>Retry</Button>} data-sentry-element="StatusDisplay" data-sentry-component="AdaptationErrorRetry" data-sentry-source-file="AdaptationErrorRetry.tsx" />;
};